<template>
  <section>
    <div class="image-container text-md-center">
      <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" v-if="!blob">
         <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
      </svg>
      <img v-bind:src="blob" style="max-width: 200px; max-height: 150px;" @click="expand" />
      <div class="image-actions text-md-center" v-if="this.controls">
        <!-- <div>
          <a v-on:click.prevent="expand" title="Expandir" href="#">
            <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path fill="currentColor" d="M10 5h-3l5-5 5 5h-3v3h-4v-3zm4 14h3l-5 5-5-5h3v-3h4v3zm-9-5v3l-5-5 5-5v3h3v4h-3zm14-4v-3l5 5-5 5v-3h-3v-4h3z"/>
            </svg>
          </a>
        </div> -->
        <v-spacer></v-spacer>
        <div>
          <a v-on:click.prevent="download" title="Descargar" href="#">
            <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path fill="currentColor" d="M15,7h-3V1H8v6H5l5,5L15,7z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757l3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408L5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449l0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074C20.096,14.468,19.828,14.053,19.338,13.532z"/>
            </svg>
          </a>
        </div>
      </div>
    </div><br/>
    <v-dialog v-model="dialog" persistent :max-width="820">
      <v-card>
        <v-card-title class="headline">
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="text-md-center">
          <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" v-if="descargado.length==0">
             <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
          </svg>
          <div v-for="(imagen, index) in descargado" :key="index">
            <img v-bind:src="imagen" style="max-width: 800px;max-height: 600px;" />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import axios from 'axios';
export default {
  props: {
    msg_id: {
      type: String,
      default: null
    },
    caso: {
      type: Number,
      default: null
    },
    file: {
      type: String,
      default: null
    },
    mime: {
      type: String,
      default: null
    },
    controls: {
      type: Boolean,
      default: true
    }
  },
  created () {
    this.innerLoop = this.loop;
  },
  beforeDestroy () {},
  mounted () {
    this.donwloadFile(this.file, this.mime);
  },
  data () {
    return {
      dialog: false,
      blob: null,
      original: null,
      descargado: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    async expand () {
      if (this.controls) {
        this.dialog = true;
        if (!this.blob) {
          await this.donwloadFile(this.file, this.mime);
        }
        if (!this.original) {
          await this.donwloadOriginal();
        }
      } else {
        this.$emit('clicked');
      }
    },
    async donwloadFile (url, type) {
      if (url.indexOf('data:') === -1) {
        let _urlTarget = `${url}`;
        if (url.indexOf('http') === -1) {
          _urlTarget = `${process.env.API_URL}${url}`;
        }
        try {
          return new Promise((resolve, reject) => {
            axios({
              url: _urlTarget,
              method: 'GET',
              responseType: 'arraybuffer',
              headers: {
                Authorization: `${this.$authToken} ${this.$storage.get('token')}`
              }
            }).then(response => {
              let file = new window.Blob([response.data], { type: type });
              this.blob = window.URL.createObjectURL(file);
            })
            .catch(err => {
              // this.$message.error(err.message);
              console.log(err.message);
              this.blob = this.file;
            });
          });
        } catch (err) {
          // this.$message.error(err.message);
          this.blob = this.file;
        }
      } else {
        this.blob = this.file;
      }
    },
    async donwloadOriginal () {
      // this.$loading.show('Preparando imagen...');
      this.descargado = [];
      try {
        let url = `system/mensajes/descargar/${this.caso}/${this.msg_id}`;
        return new Promise((resolve, reject) => {
          axios({
            url: `${process.env.API_URL}${url}`,
            method: 'GET',
            responseType: 'arraybuffer',
            headers: {
              Authorization: `${this.$authToken} ${this.$storage.get('token')}`
            }
          }).then(response => {
            this.$loading.hide();
            let _options = {};
            if (response.headers && response.headers.hasOwnProperty(`content-type`)) {
              _options.type = response.headers['content-type'];
            }
            let file = new window.Blob([response.data], _options);
            this.original = window.URL.createObjectURL(file);
            this.descargado.push(this.original);
            // this.$message.success(`El archivo original esta preparado para su Descarga!`, null, { timeout: 2000 });
          })
          .catch(err => {
            // this.$message.error(err.message);
            console.log(err.message);
            this.$loading.hide();
            this.original = this.blob;
            this.descargado.push(this.original);
            // this.$message.success(`El archivo original esta preparado para su Descarga!`, null, { timeout: 2000 });
          });
        });
      } catch (err) {
        this.$loading.hide();
        this.$message.error(err.message);
        this.original = this.blob;
        this.descargado.push(this.original);
        // this.$message.success(`El archivo original esta preparado para su Descarga!`, null, { timeout: 2000 });
      }
    },
    async download () {
      if (!this.blob) {
        await this.donwloadFile(this.file, this.mime);
      }
      if (!this.original) {
        await this.donwloadOriginal();
      }
      const link = document.createElement('a');
      link.href = this.original;
      link.setAttribute('target', '_blank');
      link.setAttribute('download', `Archivo`);
      document.body.appendChild(link);
      link.click();
    }
  },
  updated () {},
  components: {axios}
};
</script>
<style src="./imagen.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/common/plugins/imagen/Imagen.vue